import styled from 'styled-components'

import backgroundImage from './assets/flow-builder-preview-bg.jpg'

export const StyledTestWebchatAppContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-image: url(${backgroundImage});
  background-size: cover;
`
